import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.example.site_web.components.layouts.MarkdownLayout as _org_example_site_web_components_layouts_MarkdownLayout
import org.example.site_web.components.layouts.PageLayout as _org_example_site_web_components_layouts_PageLayout
import org.example.site_web.pages.IndeffiPage as _org_example_site_web_pages_IndeffiPage
import org.example.site_web.pages.LegalNoticePage as _org_example_site_web_pages_LegalNoticePage
import org.example.site_web.pages.NewHomePage as _org_example_site_web_pages_NewHomePage
import org.example.site_web.pages.Offers3Page as _org_example_site_web_pages_Offers3Page
import org.example.site_web.pages.OffersPage as _org_example_site_web_pages_OffersPage
import org.example.site_web.pages.PreviousHomePage as _org_example_site_web_pages_PreviousHomePage
import org.example.site_web.pages.ProjectsPage as _org_example_site_web_pages_ProjectsPage
import org.example.site_web.pages.WebsiteCreditsPage as _org_example_site_web_pages_WebsiteCreditsPage
import org.example.site_web.pages.WhoAreWePage as _org_example_site_web_pages_WhoAreWePage
import org.example.site_web.pages.tests.TestsPage as _org_example_site_web_pages_tests_TestsPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Accelarge Innovations"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "org.example.site_web.components.layouts.MarkdownLayout",
            parentLayoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _org_example_site_web_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "org.example.site_web.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _org_example_site_web_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initIndexPage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_NewHomePage()
        }
        ctx.router.register(
            "/-index",
            layoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initPreviousHomePage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_PreviousHomePage()
        }
        ctx.router.register(
            "/indeffi",
            layoutId = "org.example.site_web.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initIndeffiPage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_IndeffiPage()
        }
        ctx.router.register(
            "/legal-notice",
            layoutId = "org.example.site_web.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initLegalNoticePage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_LegalNoticePage()
        }
        ctx.router.register(
            "/offers",
            layoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initOffersPage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_OffersPage()
        }
        ctx.router.register(
            "/offers3",
            layoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initOffers3Page(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_Offers3Page()
        }
        ctx.router.register(
            "/projects",
            layoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initProjectsPage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_ProjectsPage()
        }
        ctx.router.register(
            "/tests/promise",
        ) { pageCtx -> 
            _org_example_site_web_pages_tests_TestsPage()
        }
        ctx.router.register(
            "/website-credits",
            layoutId = "org.example.site_web.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initWebsiteCreditsPage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_WebsiteCreditsPage()
        }
        ctx.router.register(
            "/who-are-we",
            layoutId = "org.example.site_web.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                org.example.site_web.pages.initWhoAreWePage(ctx)
            },
        ) { pageCtx -> 
            _org_example_site_web_pages_WhoAreWePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", org.example.site_web.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", org.example.site_web.SubheadlineTextStyle)
        ctx.theme.registerStyle("markdown", org.example.site_web.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", org.example.site_web.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("footer", org.example.site_web.components.sections.FooterStyle)
        ctx.theme.registerStyle("menu-footer", org.example.site_web.components.sections.MenuFooterStyle)
        ctx.theme.registerStyle("bzh-logo", org.example.site_web.components.sections.BzhLogoStyle)
        ctx.theme.registerStyle("hero-acc-container", org.example.site_web.components.sections.HeroAccContainerStyle)
        ctx.theme.registerStyle("hero-acc-box", org.example.site_web.components.sections.HeroAccBoxStyle)
        ctx.theme.registerStyle("hero-acc-container-background", org.example.site_web.components.sections.HeroAccContainerBackgroundStyle)
        ctx.theme.registerStyle("nav-header-background", org.example.site_web.components.sections.NavHeaderBackgroundStyle)
        ctx.theme.registerStyle("nav-header-darkened-background", org.example.site_web.components.sections.NavHeaderDarkenedBackgroundStyle)
        ctx.theme.registerStyle("nav-header", org.example.site_web.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("menu-header", org.example.site_web.components.sections.MenuHeaderStyle)
        ctx.theme.registerStyle("logo", org.example.site_web.components.sections.LogoStyle)
        ctx.theme.registerStyle("our-offer-container-background", org.example.site_web.components.sections.OurOfferContainerBackgroundStyle)
        ctx.theme.registerStyle("your-needs-container-background", org.example.site_web.components.sections.YourNeedsContainerBackgroundStyle)
        ctx.theme.registerStyle("form-acc", org.example.site_web.components.widgets.FormAccStyle)
        ctx.theme.registerStyle("label2", org.example.site_web.components.widgets.form.Label2Style)
        ctx.theme.registerStyle("description2", org.example.site_web.components.widgets.form.Description2Style)
        ctx.theme.registerStyle("input-edit-show-only", org.example.site_web.components.widgets.form.InputEditShowOnlyStyle)
        ctx.theme.registerStyle("input-edit", org.example.site_web.components.widgets.form.InputEditStyle)
        ctx.theme.registerStyle("text-area-show-only-field", org.example.site_web.components.widgets.form.TextAreaShowOnlyFieldStyle)
        ctx.theme.registerStyle("text-area-edit", org.example.site_web.components.widgets.form.TextAreaEditStyle)
        ctx.theme.registerStyle("image-div", org.example.site_web.components.widgets.imageDivStyle)
        ctx.theme.registerStyle("image", org.example.site_web.components.widgets.imageStyle)
        ctx.theme.registerStyle("offers2-page", org.example.site_web.pages.offers2PageStyle)
        ctx.theme.registerStyle("manifest2", org.example.site_web.pages.manifest2Style)
        ctx.theme.registerStyle("list-bullet", org.example.site_web.pages.listBulletStyle)
        ctx.theme.registerStyle("offers-page", org.example.site_web.pages.offersPageStyle)
        ctx.theme.registerStyle("manifest", org.example.site_web.pages.manifestStyle)
        ctx.theme.registerStyle("project-paraph", org.example.site_web.pages.projectParaphStyle)
        ctx.theme.registerStyle("hero-container", org.example.site_web.pages.HeroContainerStyle)
        ctx.theme.registerStyle("home-grid", org.example.site_web.pages.HomeGridStyle)
        ctx.theme.registerStyle("anim-grid", org.example.site_web.pages.AnimGridStyle)
        ctx.theme.registerStyle("home-grid-cell", org.example.site_web.pages.HomeGridCellStyle)
        ctx.theme.registerVariant("-circle", org.example.site_web.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", org.example.site_web.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", org.example.site_web.components.sections.SideMenuSlideInAnim)
        org.example.site_web.initColorMode(ctx)
        org.example.site_web.initStyles(ctx)
        org.example.site_web.initSiteStyles(ctx)
        org.example.site_web.components.sections.initNavHeaderHeight(ctx)
        org.example.site_web.initTheme(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.example.site_web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
